module.exports = __webpack_public_path__ + "static/media/Low.4e883e1a.png";